import { Dialog, DialogContent, styled } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import Settings from '../../../webjam/components/settings';
import { showMixerSettingsModal } from '../../redux/tool-webjam-v2/actions';

export const MixerSettings = () => {
    const dispatch = useDispatch();
    return <BootstrapDialog
        // tabIndex={-1}
        className='mixer-popup-wrapper'
        fullWidth={true}
        maxWidth="md"
        data-testid="mixer-tab"
        id='mixer-tab'
        // onClose={handleClose}
        // aria-labelledby="customized-dialog-title"
        open={true}
      >
        <DialogContent dividers className='dialog-content-wrapper mixer-dialog-content-wrapper'>
        <div className="container-fluid mixer maxplayer_ui">
            <Settings onClose={() => dispatch(showMixerSettingsModal(false))} />
        </div>
         </DialogContent>
         </BootstrapDialog>
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      height: 500
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
      margin: '0px'
    },
    '& .MuiDialog-paperFullWidth': {
      width: 'calc(100% - 20px )'
    },
    '& .dialog-content-wrapper': {
      border: 'none'
    }  
  }));